import React, { Component } from 'react';
import { app } from "@microsoft/teams-js";

// Create new context
export const MyContext = React.createContext();

// Then create a Provider Component
export class MyProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: "",
            language_en: require('./translations/en.json'),
        };
        this.getTranslation = this.getTranslation.bind(this);
        this.getUserLanguage = this.getUserLanguage.bind(this); 
    }

    componentDidMount() {
        this.getUserLanguage();
    }

    // Get the translation for a word from json based on pageKey and wordKey
    getTranslation(pageKey, wordKey) {
        var language = this.getLanguageJson();
        if (language && language[pageKey] && language[pageKey][wordKey]) {
            var translation = language[pageKey][wordKey].translation;
            return translation;
        } else if (this.state.language_en && this.state.language_en[pageKey] && this.state.language_en[pageKey][wordKey]) {
            var translationEn = this.state.language_en[pageKey][wordKey].translation;
            return translationEn;
        } else {
            return wordKey;
        }
    }

    // Get json translation file based on the browser language
    getLanguageJson() {
        let browserLanguage = this.state.language;

        switch (browserLanguage.toLowerCase()) {
            case "ro":
                var RO = require('./translations/ro.json');
                return RO;
            case "de":
            case "de-de":
            case "de-li":
            case "de-lu":
            case "de-ch":
            case "de-at":
                var DE = require('./translations/de.json');
                return DE;
            case "ja":
            case "ja-jp":
                var JA = require('./translations/ja.json');
                return JA;
            case "nl":
            case "nl-nl":
                var NL = require('./translations/nl.json');
                return NL;
            case "fr":
            case "fr-ca":
            case "fr-ch":
            case "fr-fr":
                var FR = require('./translations/fr.json');
                return FR;
            case "zh-tw":
            case "zh-hant":
                var ZH = require('./translations/zh-Hant.json');
                return ZH;
            case "es":
            case "es-sp":
            case "es-ar":
            case "es-bo":
            case "es-cl":
            case "es-co":
            case "es-cr":
            case "es-cu":
            case "es-do":
            case "es-ec":
            case "es-sv":
            case "es-gt":
            case "es-hn":
            case "es-mx":
            case "es-ni":
            case "es-py":
            case "es-pe":
            case "es-pr":
            case "es-es":
            case "es-uy":
            case "es-us":
            case "es-ve":
                var ES = require('./translations/es.json');
                return ES;
            case "pt":
            case "pt-pt":
                var PT = require('./translations/pt.json');
                return PT;
            case "pt-br":
                var PT_BR = require('./translations/pt-br.json');
                return PT_BR;
            case "sv-se":
            case "sv":
                var SV = require('./translations/se.json');
                return SV;
            case "it":
            case "it-it":
                var IT = require('./translations/it.json');
                return IT;
            default:
                var EN = require('./translations/en.json');
                return EN;
        }
    }

    // Get user language and update state
    getUserLanguage() {
        let navigatorLanguage;

        // Pr�fen, ob Teams-Context vorhanden ist
        app.initialize().then(() => {
            app.getContext().then((context) => {
                this.setState({ language: context.app.locale });
            }).catch(() => {
                // Fallback auf Browser-Sprache
                navigatorLanguage = navigator.language || navigator.userLanguage;
                this.setState({ language: navigatorLanguage });
            });
        }).catch(() => {
            // Fallback auf Browser-Sprache
            navigatorLanguage = navigator.language || navigator.userLanguage;
            this.setState({ language: navigatorLanguage });
        }); 
    }


    render() {
        return (
            <MyContext.Provider value={{
                state: this.state,
                getTranslation: this.getTranslation,
                language:this.state.language
            }}>
                {this.props.children}
            </MyContext.Provider>
        );
    }
}

export const getUserLanguage = () => {

    let navigatorLanguage;

    // Pr�fen, ob Teams-Context vorhanden ist
    app.initialize().then(() => {
        app.getContext().then((context) => {
            navigatorLanguage = context.app.locale;
        }).catch(() => {
            // Fallback auf Browser-Sprache bei Fehler
            navigatorLanguage = navigator.language || navigator.userLanguage;
        });
    }).catch(() => {
        // Fallback auf Browser-Sprache
        navigatorLanguage = navigator.language || navigator.userLanguage;
    }); 

    return navigatorLanguage;
}